<script>
import Label from "../form-components/Label.vue";
import Multiselect from "vue-multiselect";
import * as categoryService from '../../../components/service/category.service';

export default {
  props: {
    item_key: {
      type: String,
      required: true,
    },
    item_value: {
      // type: String,
      required: false,
    },
    item: {
      type: Object,
      required: true,
    },
    submitted: {
      type: Boolean,
      required: true,
    },
    validation: {
      type: Object,
      required: true,
    },
    last_updated: {
      type: Object,
      required: false,
    },
    selectedItem: {
      type: Object,
      required: false,
    },
    updateValue: {
      type: Function,
      required: true
    }
  },
  components: {
    Label,
    Multiselect,
  },
  data() {
    return {
      value: null,
      options: [],
    };
  },
  watch: {
    item_value: {
      handler(val) {
        this.value = val;
      },
      deep: true,
    },
    value(val) {
        this.updateValue(this.item_key, val)
    },
  },
  methods: {
    async getOptions() {
      let filter = {
        "where": {
          "name": "Locations",
          "cmsId": this.$route.params.cmsId
        },
        "include": [
          {
            "relation": "pages"
          }
        ]
      };

      filter = encodeURIComponent(JSON.stringify(filter));
      
      let data = await categoryService.getWithFilter(filter)
      let pages = data[0].pages;
      if(pages) this.options = pages;
      if(pages.length == 1) this.value = pages[0]
    },
  },
  mounted() {
    this.getOptions();
  },
};
</script>
<template>
  <div class="mb-3" :class="{ 'd-none': item.displayOn && !display_none_check }">
    <Label :item="item" />
    <multiselect
      track-by="title"
      label="title"
      v-model="value"
      :options="options"
      :searchable="options.length > 5 ? true : false"
      :close-on-select="true"
      :show-labels="false"
      :placeholder="item.placeholder"
      :allow-empty="false"
      :preselectFirst="false"
    >
      <template slot="singleLabel" slot-scope="{ option }"
        ><strong>{{ option.title }}</strong></template
      >
    </multiselect>
    <div v-if="submitted && validation.$error" class="invalid-feedback">
      <span v-if="!validation.required">This value is required.</span>
    </div>
  </div>
</template>



